(function () {
  const SELECTOR = '.m108-reveal';

  function revealWithin(root) {
    const items = Array.from(root.querySelectorAll(SELECTOR)).filter((item) => !item.dataset.m108Observed);
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    items.forEach((item) => {
      item.dataset.m108Observed = 'true';
      observer.observe(item);
    });
  }

  function initTrustStrips(root) {
    const strips = Array.from(root.querySelectorAll('[data-m108-trust-strip]'));
    if (root.matches && root.matches('[data-m108-trust-strip]')) strips.unshift(root);

    strips.forEach((strip) => {
      if (strip.dataset.m108TrustBound === 'true') return;
      const toggle = strip.querySelector('[data-m108-trust-toggle]');
      if (!toggle) return;

      strip.dataset.m108TrustBound = 'true';
      toggle.addEventListener('click', () => {
        const paused = strip.dataset.m108Paused !== 'true';
        strip.dataset.m108Paused = paused ? 'true' : 'false';
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      });
    });
  }

  function init(root) {
    revealWithin(root || document);
    initTrustStrips(root || document);
    initSkinQuiz(root || document);
    initQuickLangToggle(root || document);
    initGeoLangSuggest(root || document);
    initWelcomeOffer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // ══ M108 SKİN QUİZ ══════════════════════════════════════════════════════
  // Puanlama mantığı build_quiz_logic.py ile 4096 kombinasyonun tamamı
  // denenerek doğrulandı (proje arşivi). Bu dosya yalnızca o mantığın
  // JS karşılığıdır — eşikleri burada DEĞİŞTİRME, Python'daki doğrulama
  // geçersiz kalır.
  function initSkinQuiz(root) {
    var sections = root.querySelectorAll ? root.querySelectorAll('[data-m108-quiz]') : [];
    if (root.matches && root.matches('[data-m108-quiz]')) sections = [root];

    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.m108QuizBound === 'true') return;
      section.dataset.m108QuizBound = 'true';
      bindQuiz(section);
    });
  }

  function bindQuiz(section) {
    var qEl = section.querySelector('[data-m108-quiz-questions]');
    var cUrlEl = section.querySelector('[data-m108-quiz-content-url]');
    var pEl = section.querySelector('[data-m108-quiz-products]');
    if (!qEl || !cUrlEl || !pEl) return;

    var DATA, PRODUCTS, contentUrl;
    try {
      DATA = JSON.parse(qEl.textContent);
      PRODUCTS = JSON.parse(pEl.textContent);
      contentUrl = JSON.parse(cUrlEl.textContent);
    } catch (e) {
      return; // bozuk veri: sessizce hiçbir şey render etme, sayfa kırılmasın
    }

    fetch(contentUrl)
      .then(function (r) { return r.json(); })
      .then(function (CONTENT) { bindQuizWithContent(section, DATA, CONTENT, PRODUCTS); })
      .catch(function () {}); // ağ hatası: sessizce hiçbir şey render etme, sayfa kırılmasın
  }

  function bindQuizWithContent(section, DATA, CONTENT, PRODUCTS) {

    // Multi-locale support: LANG resolves to any of SUPPORTED, falling back to 'en'.
    // Content lookups (tObj/tField) fall back to English per-field if a given locale
    // hasn't been translated for that specific string yet -- adding a new language is
    // purely a content change (fill in more keys below / in the JSON data blocks),
    // never a code change.
    var SUPPORTED = ['en','tr','de','es','fr','ar','ru','it','nl','pl','az','ko','bg','cs','da','el','hu','pt-pt','ro','sv'];
    var LANG = (function () {
      var raw = (document.documentElement.lang || 'en').toLowerCase();
      if (SUPPORTED.indexOf(raw) !== -1) return raw;
      var short = raw.split('-')[0];
      return SUPPORTED.indexOf(short) !== -1 ? short : 'en';
    })();
    // Back-compat single-arg shim: some call sites still pass (trValue, enValue) pairs
    // for the few strings that haven't been migrated to the I18N_BY_LANG dictionary.
    var t = function (primary, en) { return LANG === 'tr' && primary !== undefined ? primary : en; };
    // Generic getter for inline records shaped {en:"...", tr:"...", de:"...", ...}
    // (used by question/option objects in the quiz JSON, which already carry en/tr
    // and can gain more locale keys directly without any structural change).
    var tObj = function (obj) {
      if (!obj) return '';
      return (obj[LANG] !== undefined ? obj[LANG] : obj.en) || '';
    };
    // Generic getter for flat `<field>_<lang>` suffixed keys on a record (used by the
    // outcome/addon content blocks, e.g. name_tr/name_en/name_de/...).
    var tField = function (record, field) {
      if (!record) return '';
      var v = record[field + '_' + LANG];
      if (v === undefined) v = record[field + '_en'];
      return v || '';
    };

    var I18N_BY_LANG = {
      en: {
        start: 'Start the Quiz',
        meta: '6 questions · under 2 minutes',
        back: 'Back',
        next: 'Continue',
        progress: function (i, n) { return 'Question ' + i + ' of ' + n; },
        guessSame: 'Your guess was right.',
        guessDiff: function (guess, real) { return 'You guessed "' + guess + '" — the test says "' + real + '".'; },
        resultKicker: 'Your result',
        routineTitle: 'Your ritual',
        addonTitle: 'Also worth a look',
        tipTitle: 'One small habit',
        addToCart: 'Add ritual to cart',
        adding: 'Adding…',
        added: 'Added to cart',
        viewProduct: 'View product',
        retake: 'Retake the quiz',
        disclaimerTitle: 'Worth knowing',
        disclaimer: 'This quiz is a cosmetic guide to product choice, not a medical assessment. If you notice a persistent skin concern, please see a professional.',
        spfTitle: 'One addition for daytime',
        spf: 'On top of your daytime moisturiser, add a season-appropriate sun protection.',
        spfLink: 'Browse Sun Care',
      },
      tr: {
        start: 'Teste Başla',
        meta: '6 soru · 2 dakikadan az',
        back: 'Geri',
        next: 'Devam',
        progress: function (i, n) { return 'Soru ' + i + ' / ' + n; },
        guessSame: 'Tahminin doğru çıktı.',
        guessDiff: function (guess, real) { return 'Sen "' + guess + '" sanıyordun, testin sonucu: "' + real + '".'; },
        resultKicker: 'Sonucun',
        routineTitle: 'Senin için ritüel',
        addonTitle: 'Ayrıca fark ettiysen',
        tipTitle: 'Küçük bir alışkanlık',
        addToCart: 'Ritüeli sepete ekle',
        adding: 'Ekleniyor…',
        added: 'Sepete eklendi',
        viewProduct: 'Ürüne git',
        retake: 'Testi yeniden yap',
        disclaimerTitle: 'Bilinmesi gereken',
        disclaimer: 'Bu test kozmetik bir tercih rehberidir; tıbbi değerlendirmenin yerine geçmez. Cildinizde kalıcı bir sorun fark ederseniz bir uzmana danışın.',
        spfTitle: 'Gündüz rutinine ek',
        spf: 'Gündüz nemlendiricinizin üstüne, mevsime uygun bir güneş koruma eklemeyi unutmayın.',
        spfLink: 'Güneş Bakımı koleksiyonuna bakın',
      },
      "de": {
        start: "Test starten",
        meta: "6 Fragen · unter 2 Minuten",
        back: "Zurück",
        next: "Weiter",
        progress: function (i, n) { return "Frage " + i + " von " + n; },
        guessSame: "Ihre Vermutung war richtig.",
        guessDiff: function (guess, real) { return "Sie vermuteten „" + guess + "“ – das Testergebnis lautet „" + real + "“."; },
        resultKicker: "Ihr Ergebnis",
        routineTitle: "Ihr Ritual",
        addonTitle: "Ebenfalls einen Blick wert",
        tipTitle: "Eine kleine Gewohnheit",
        addToCart: "Ritual in den Warenkorb legen",
        adding: "Wird hinzugefügt…",
        added: "Zum Warenkorb hinzugefügt",
        viewProduct: "Produkt ansehen",
        retake: "Test wiederholen",
        disclaimerTitle: "Gut zu wissen",
        disclaimer: "Dieser Test ist ein kosmetischer Leitfaden zur Produktauswahl und ersetzt keine medizinische Beurteilung. Falls Sie ein anhaltendes Hautproblem bemerken, wenden Sie sich bitte an eine Fachperson.",
        spfTitle: "Eine Ergänzung für tagsüber",
        spf: "Ergänzen Sie Ihre Tagespflege um einen der Jahreszeit entsprechenden Sonnenschutz.",
        spfLink: "Sonnenpflege entdecken",
      },
      "ru": {
        start: "Начать тест",
        meta: "6 вопросов · менее 2 минут",
        back: "Назад",
        next: "Далее",
        progress: function (i, n) { return "Вопрос " + i + " из " + n; },
        guessSame: "Ваше предположение оказалось верным.",
        guessDiff: function (guess, real) { return "Вы предположили «" + guess + "» — по результату теста: «" + real + "»."; },
        resultKicker: "Ваш результат",
        routineTitle: "Ваш ритуал",
        addonTitle: "Также обратите внимание",
        tipTitle: "Небольшая привычка",
        addToCart: "Добавить ритуал в корзину",
        adding: "Добавление…",
        added: "Добавлено в корзину",
        viewProduct: "Перейти к товару",
        retake: "Пройти тест заново",
        disclaimerTitle: "Важно знать",
        disclaimer: "Этот тест — косметический ориентир для выбора продуктов, а не медицинское заключение. Если Вы заметили стойкую проблему с кожей, пожалуйста, обратитесь к специалисту.",
        spfTitle: "Дополнение к дневному уходу",
        spf: "Поверх Вашего дневного увлажняющего крема добавьте солнцезащитное средство, подходящее для сезона.",
        spfLink: "Смотреть коллекцию «Солнцезащита»",
      },
      "es": {
        start: "Comenzar el test",
        meta: "6 preguntas · menos de 2 minutos",
        back: "Atrás",
        next: "Continuar",
        progress: function (i, n) { return "Pregunta " + i + " de " + n; },
        guessSame: "Ha acertado.",
        guessDiff: function (guess, real) { return "Pensaba que era «" + guess + "» — el resultado es «" + real + "»."; },
        resultKicker: "Su resultado",
        routineTitle: "Su ritual",
        addonTitle: "También merece un vistazo",
        tipTitle: "Un pequeño hábito",
        addToCart: "Añadir el ritual a la cesta",
        adding: "Añadiendo…",
        added: "Añadido a la cesta",
        viewProduct: "Ver producto",
        retake: "Repetir el test",
        disclaimerTitle: "Conviene saberlo",
        disclaimer: "Este test es una guía cosmética para elegir productos, no una evaluación médica. Si nota una alteración cutánea persistente, consulte a un profesional.",
        spfTitle: "Un paso más para el día",
        spf: "Además de su crema hidratante de día, añada una protección solar adecuada a la época del año.",
        spfLink: "Ver la colección de Protección Solar",
      },
      "fr": {
        start: "Commencer le test",
        meta: "6 questions · moins de 2 minutes",
        back: "Retour",
        next: "Continuer",
        progress: function (i, n) { return "Question " + i + " sur " + n; },
        guessSame: "Votre intuition était juste.",
        guessDiff: function (guess, real) { return "Vous pensiez « " + guess + " » — le test indique « " + real + " »."; },
        resultKicker: "Votre résultat",
        routineTitle: "Votre rituel",
        addonTitle: "À découvrir aussi",
        tipTitle: "Une petite habitude",
        addToCart: "Ajouter le rituel au panier",
        adding: "Ajout en cours…",
        added: "Ajouté au panier",
        viewProduct: "Voir le produit",
        retake: "Refaire le test",
        disclaimerTitle: "Bon à savoir",
        disclaimer: "Ce test est un guide cosmétique pour orienter votre choix de produits, et non une évaluation médicale. Si vous constatez un problème de peau persistant, consultez un professionnel de santé.",
        spfTitle: "Un complément pour la journée",
        spf: "En complément de votre soin hydratant de jour, ajoutez une protection solaire adaptée à la saison.",
        spfLink: "Découvrir les Soins Solaires",
      },
      "ar": {
        start: "ابدئي الاختبار",
        meta: "6 أسئلة · أقل من دقيقتين",
        back: "رجوع",
        next: "متابعة",
        progress: function (i, n) { return "السؤال " + i + " من " + n; },
        guessSame: "تخمينك كان صحيحًا.",
        guessDiff: function (guess, real) { return "خمّنتِ «" + guess + "» — بينما نتيجة الاختبار هي «" + real + "»."; },
        resultKicker: "نتيجتك",
        routineTitle: "طقسك",
        addonTitle: "يستحق الاهتمام أيضًا",
        tipTitle: "عادة صغيرة واحدة",
        addToCart: "أضيفي الطقس إلى السلة",
        adding: "جارٍ الإضافة…",
        added: "تمت الإضافة إلى السلة",
        viewProduct: "عرض المنتج",
        retake: "أعيدي الاختبار",
        disclaimerTitle: "جدير بالمعرفة",
        disclaimer: "هذا الاختبار دليل تجميلي لاختيار المنتج المناسب، وليس تقييمًا طبيًا. إذا لاحظتِ مشكلة جلدية مستمرة، يُرجى استشارة أخصائي.",
        spfTitle: "إضافة واحدة لروتين النهار",
        spf: "بالإضافة إلى مرطب النهار، احرصي على استخدام واقي شمس مناسب للموسم.",
        spfLink: "تصفحي مجموعة العناية بالشمس",
      },
      "it": {
        start: "Inizia il Test",
        meta: "6 domande · meno di 2 minuti",
        back: "Indietro",
        next: "Continua",
        progress: function (i, n) { return "Domanda " + i + " di " + n; },
        guessSame: "La Sua previsione era corretta.",
        guessDiff: function (guess, real) { return "Lei aveva ipotizzato \"" + guess + "\" — il test indica \"" + real + "\"."; },
        resultKicker: "Il Suo risultato",
        routineTitle: "Il Suo rituale",
        addonTitle: "Da scoprire anche",
        tipTitle: "Una piccola abitudine",
        addToCart: "Aggiungi il rituale al carrello",
        adding: "Aggiunta in corso…",
        added: "Aggiunto al carrello",
        viewProduct: "Vedi il prodotto",
        retake: "Rifai il test",
        disclaimerTitle: "Da sapere",
        disclaimer: "Questo test è una guida cosmetica alla scelta dei prodotti, non una valutazione medica. Se nota un problema cutaneo persistente, La invitiamo a consultare uno specialista.",
        spfTitle: "Un'aggiunta per il giorno",
        spf: "Oltre alla Sua crema idratante da giorno, aggiunga una protezione solare adatta alla stagione.",
        spfLink: "Scopra la collezione Solari",
      },
      "nl": {
        start: "Start de quiz",
        meta: "6 vragen · minder dan 2 minuten",
        back: "Terug",
        next: "Doorgaan",
        progress: function (i, n) { return "Vraag " + i + " van " + n; },
        guessSame: "Je gok klopte.",
        guessDiff: function (guess, real) { return "Je dacht \"" + guess + "\" — de test zegt \"" + real + "\"."; },
        resultKicker: "Jouw resultaat",
        routineTitle: "Jouw ritueel",
        addonTitle: "Ook de moeite waard",
        tipTitle: "Eén kleine gewoonte",
        addToCart: "Voeg ritueel toe aan winkelwagen",
        adding: "Toevoegen…",
        added: "Toegevoegd aan winkelwagen",
        viewProduct: "Bekijk product",
        retake: "Doe de quiz opnieuw",
        disclaimerTitle: "Goed om te weten",
        disclaimer: "Deze quiz is een cosmetische gids voor productkeuze, geen medische beoordeling. Merk je een aanhoudende huidklacht op, raadpleeg dan een specialist.",
        spfTitle: "Eén aanvulling voor overdag",
        spf: "Voeg naast je dagcrème een zonbescherming toe die bij het seizoen past.",
        spfLink: "Bekijk Zonverzorging",
      },
      "pl": {
        start: "Rozpocznij test",
        meta: "6 pytań · poniżej 2 minut",
        back: "Wstecz",
        next: "Dalej",
        progress: function (i, n) { return "Pytanie " + i + " z " + n; },
        guessSame: "Pani przeczucie było trafne.",
        guessDiff: function (guess, real) { return "Pani typ: „" + guess + "” — wynik testu: „" + real + "”."; },
        resultKicker: "Pani wynik",
        routineTitle: "Rytuał dla Pani",
        addonTitle: "Warto również zobaczyć",
        tipTitle: "Jeden mały nawyk",
        addToCart: "Dodaj rytuał do koszyka",
        adding: "Dodawanie…",
        added: "Dodano do koszyka",
        viewProduct: "Zobacz produkt",
        retake: "Powtórz test",
        disclaimerTitle: "Warto wiedzieć",
        disclaimer: "Ten test to kosmetyczny przewodnik po wyborze produktów, a nie ocena medyczna. Jeśli zauważy Pani utrzymujący się problem skórny, prosimy o konsultację ze specjalistą.",
        spfTitle: "Jedno uzupełnienie na dzień",
        spf: "Na krem nawilżający stosowany w ciągu dnia warto nałożyć ochronę przeciwsłoneczną dopasowaną do pory roku.",
        spfLink: "Zobacz kolekcję ochrony przeciwsłonecznej",
      },
      "az": {
        start: "Testə Başlayın",
        meta: "6 sual · 2 dəqiqədən az",
        back: "Geri",
        next: "Davam et",
        progress: function (i, n) { return "Sual " + i + " / " + n; },
        guessSame: "Təxmininiz doğru çıxdı.",
        guessDiff: function (guess, real) { return "Siz \"" + guess + "\" deyə təxmin etmişdiniz — testin nəticəsi: \"" + real + "\"."; },
        resultKicker: "Nəticəniz",
        routineTitle: "Sizin üçün ritual",
        addonTitle: "Bunlara da baxmağa dəyər",
        tipTitle: "Kiçik bir vərdiş",
        addToCart: "Ritualı səbətə əlavə edin",
        adding: "Əlavə edilir…",
        added: "Səbətə əlavə edildi",
        viewProduct: "Məhsula baxın",
        retake: "Testi yenidən keçin",
        disclaimerTitle: "Bilməli olduqlarınız",
        disclaimer: "Bu test məhsul seçimində kömək edən kozmetik bir bələdçidir və tibbi qiymətləndirmənin yerini tutmur. Dərinizdə davamlı bir problem fark etsəniz, mütəxəssisə müraciət edin.",
        spfTitle: "Gündüz rutininə əlavə",
        spf: "Gündüz nəmləndiricinizin üzərinə, mövsümə uyğun bir günəş qoruyucusu əlavə etməyi unutmayın.",
        spfLink: "Günəş Baxımı kolleksiyasına baxın",
      },
      "ko": {
        start: "테스트 시작하기",
        meta: "6문항 · 2분 이내",
        back: "이전",
        next: "다음",
        progress: function (i, n) { return "질문 " + i + " / " + n; },
        guessSame: "예상하신 그대로예요.",
        guessDiff: function (guess, real) { return "\"" + guess + "\"라고 예상하셨지만, 테스트 결과는 \"" + real + "\"이에요."; },
        resultKicker: "나의 결과",
        routineTitle: "나를 위한 리추얼",
        addonTitle: "이것도 살펴보세요",
        tipTitle: "작은 습관 하나",
        addToCart: "리추얼 장바구니에 담기",
        adding: "담는 중…",
        added: "장바구니에 담았어요",
        viewProduct: "제품 보기",
        retake: "테스트 다시 하기",
        disclaimerTitle: "알아두세요",
        disclaimer: "이 테스트는 제품 선택을 돕는 화장품 가이드로, 의학적 진단을 대신하지 않아요. 피부 고민이 계속된다면 전문가와 상담해 주세요.",
        spfTitle: "낮 시간에 더하면 좋은 한 가지",
        spf: "데이 크림 위에 계절에 맞는 자외선 차단제를 더해 주세요.",
        spfLink: "선케어 컬렉션 보기",
      },
      "bg": {
        start: "Започнете теста",
        meta: "6 въпроса · под 2 минути",
        back: "Назад",
        next: "Напред",
        progress: function (i, n) { return "Въпрос " + i + " от " + n; },
        guessSame: "Познахте правилно.",
        guessDiff: function (guess, real) { return "Предположихте „" + guess + "“ — тестът показва „" + real + "“."; },
        resultKicker: "Вашият резултат",
        routineTitle: "Вашият ритуал",
        addonTitle: "Също си заслужава внимание",
        tipTitle: "Един малък навик",
        addToCart: "Добавете ритуала в количката",
        adding: "Добавяне…",
        added: "Добавено в количката",
        viewProduct: "Вижте продукта",
        retake: "Повторете теста",
        disclaimerTitle: "Добре е да знаете",
        disclaimer: "Този тест е козметичен ориентир за избор на продукт, а не медицинска оценка. Ако забележите траен проблем с кожата, моля, консултирайте се със специалист.",
        spfTitle: "Едно допълнение за деня",
        spf: "Върху дневния си хидратант добавете слънцезащита, подходяща за сезона.",
        spfLink: "Разгледайте колекцията Слънцезащита",
      },
      "cs": {
        start: "Začít test",
        meta: "6 otázek · méně než 2 minuty",
        back: "Zpět",
        next: "Pokračovat",
        progress: function (i, n) { return "Otázka " + i + " z " + n; },
        guessSame: "Váš tip byl správný.",
        guessDiff: function (guess, real) { return "Váš tip: „" + guess + "“ – výsledek testu: „" + real + "“."; },
        resultKicker: "Váš výsledek",
        routineTitle: "Váš rituál",
        addonTitle: "Také stojí za pozornost",
        tipTitle: "Jeden malý návyk",
        addToCart: "Přidat rituál do košíku",
        adding: "Přidávání…",
        added: "Přidáno do košíku",
        viewProduct: "Zobrazit produkt",
        retake: "Opakovat test",
        disclaimerTitle: "Dobré vědět",
        disclaimer: "Tento test je kosmetickým průvodcem výběrem produktů, nikoli lékařským posouzením. Pokud si všimnete přetrvávajícího problému s pletí, obraťte se prosím na odborníka.",
        spfTitle: "Doplněk pro den",
        spf: "Na svůj denní krém navíc naneste ochranu proti slunci vhodnou pro dané roční období.",
        spfLink: "Prohlédnout kolekci Ochrana proti slunci",
      },
      "da": {
        start: "Start testen",
        meta: "6 spørgsmål · under 2 minutter",
        back: "Tilbage",
        next: "Fortsæt",
        progress: function (i, n) { return "Spørgsmål " + i + " af " + n; },
        guessSame: "Dit gæt var rigtigt.",
        guessDiff: function (guess, real) { return "Du gættede på \"" + guess + "\" — testen siger \"" + real + "\"."; },
        resultKicker: "Dit resultat",
        routineTitle: "Dit ritual",
        addonTitle: "Også værd at se nærmere på",
        tipTitle: "En lille vane",
        addToCart: "Læg ritual i kurv",
        adding: "Tilføjer…",
        added: "Lagt i kurv",
        viewProduct: "Se produkt",
        retake: "Tag testen igen",
        disclaimerTitle: "Værd at vide",
        disclaimer: "Denne test er en kosmetisk guide til produktvalg og erstatter ikke en medicinsk vurdering. Oplever du et vedvarende hudproblem, bør du kontakte en fagperson.",
        spfTitle: "Én tilføjelse til dagrutinen",
        spf: "Suppler din dagcreme med en solbeskyttelse, der passer til årstiden.",
        spfLink: "Udforsk Solpleje",
      },
      "el": {
        start: "Ξεκινήστε το τεστ",
        meta: "6 ερωτήσεις · λιγότερο από 2 λεπτά",
        back: "Πίσω",
        next: "Συνέχεια",
        progress: function (i, n) { return "Ερώτηση " + i + " από " + n; },
        guessSame: "Η εκτίμησή σας ήταν σωστή.",
        guessDiff: function (guess, real) { return "Νομίζατε ότι είναι «" + guess + "» — το τεστ δείχνει «" + real + "»."; },
        resultKicker: "Το αποτέλεσμά σας",
        routineTitle: "Το τελετουργικό σας",
        addonTitle: "Αξίζει επίσης να δείτε",
        tipTitle: "Μια μικρή συνήθεια",
        addToCart: "Προσθήκη τελετουργικού στο καλάθι",
        adding: "Προσθήκη…",
        added: "Προστέθηκε στο καλάθι",
        viewProduct: "Δείτε το προϊόν",
        retake: "Επαναλάβετε το τεστ",
        disclaimerTitle: "Αξίζει να γνωρίζετε",
        disclaimer: "Αυτό το τεστ είναι ένας καλλυντικός οδηγός για την επιλογή προϊόντων και όχι ιατρική αξιολόγηση. Εάν παρατηρήσετε ένα επίμονο δερματικό πρόβλημα, συμβουλευτείτε έναν ειδικό.",
        spfTitle: "Μια προσθήκη για την ημέρα",
        spf: "Πάνω από την ενυδατική σας κρέμα ημέρας, προσθέστε μια αντηλιακή προστασία κατάλληλη για την εποχή.",
        spfLink: "Δείτε τη συλλογή Ηλιοπροστασία",
      },
      "hu": {
        start: "Teszt indítása",
        meta: "6 kérdés · 2 percnél rövidebb",
        back: "Vissza",
        next: "Tovább",
        progress: function (i, n) { return i + ". kérdés / " + n; },
        guessSame: "Eltalálta.",
        guessDiff: function (guess, real) { return "Ön szerint \"" + guess + "\" volt a válasz – a teszt szerint: \"" + real + "\"."; },
        resultKicker: "Az Ön eredménye",
        routineTitle: "Az Ön rituáléja",
        addonTitle: "Ezt is érdemes megnézni",
        tipTitle: "Egy apró szokás",
        addToCart: "Rituálé hozzáadása a kosárhoz",
        adding: "Hozzáadás…",
        added: "Hozzáadva a kosárhoz",
        viewProduct: "Termék megtekintése",
        retake: "Teszt újrakezdése",
        disclaimerTitle: "Jó tudni",
        disclaimer: "Ez a teszt egy kozmetikai útmutató a termékválasztáshoz, nem orvosi értékelés. Ha tartós bőrproblémát észlel, kérjük, forduljon szakemberhez.",
        spfTitle: "Egy kiegészítés a nappali rutinhoz",
        spf: "Nappali hidratálója mellé válasszon az évszaknak megfelelő fényvédelmet is.",
        spfLink: "Napvédelem kollekció megtekintése",
      },
      "pt-pt": {
        start: "Iniciar o Teste",
        meta: "6 perguntas · menos de 2 minutos",
        back: "Voltar",
        next: "Continuar",
        progress: function (i, n) { return "Pergunta " + i + " de " + n; },
        guessSame: "O seu palpite estava certo.",
        guessDiff: function (guess, real) { return "O seu palpite foi \"" + guess + "\" — o teste diz \"" + real + "\"."; },
        resultKicker: "O seu resultado",
        routineTitle: "O seu ritual",
        addonTitle: "Também vale a pena conhecer",
        tipTitle: "Um pequeno hábito",
        addToCart: "Adicionar ritual ao carrinho",
        adding: "A adicionar…",
        added: "Adicionado ao carrinho",
        viewProduct: "Ver produto",
        retake: "Repetir o teste",
        disclaimerTitle: "Vale a pena saber",
        disclaimer: "Este teste é um guia cosmético para a escolha de produtos, não uma avaliação médica. Caso identifique uma preocupação cutânea persistente, consulte um profissional.",
        spfTitle: "Um complemento para o dia",
        spf: "Para além do seu hidratante de dia, adicione uma proteção solar adequada à estação do ano.",
        spfLink: "Ver a coleção de Proteção Solar",
      },
      "ro": {
        start: "Începeți testul",
        meta: "6 întrebări · sub 2 minute",
        back: "Înapoi",
        next: "Continuați",
        progress: function (i, n) { return "Întrebarea " + i + " din " + n; },
        guessSame: "Presupunerea dumneavoastră a fost corectă.",
        guessDiff: function (guess, real) { return "Ați presupus „" + guess + "” — rezultatul testului este „" + real + "”."; },
        resultKicker: "Rezultatul dumneavoastră",
        routineTitle: "Ritualul dumneavoastră",
        addonTitle: "Merită o privire",
        tipTitle: "Un mic obicei",
        addToCart: "Adăugați ritualul în coș",
        adding: "Se adaugă…",
        added: "Adăugat în coș",
        viewProduct: "Vedeți produsul",
        retake: "Reluați testul",
        disclaimerTitle: "Bine de știut",
        disclaimer: "Acest test este un ghid cosmetic pentru alegerea produselor, nu o evaluare medicală. Dacă observați o problemă persistentă a pielii, vă rugăm să consultați un specialist.",
        spfTitle: "O completare pentru rutina de zi",
        spf: "Pe lângă crema dumneavoastră hidratantă de zi, adăugați o protecție solară adaptată sezonului.",
        spfLink: "Explorați colecția de protecție solară",
      },
      "sv": {
        start: "Starta testet",
        meta: "6 frågor · under 2 minuter",
        back: "Tillbaka",
        next: "Fortsätt",
        progress: function (i, n) { return "Fråga " + i + " av " + n; },
        guessSame: "Din gissning stämde.",
        guessDiff: function (guess, real) { return "Du gissade ”" + guess + "” — testet säger ”" + real + "”."; },
        resultKicker: "Ditt resultat",
        routineTitle: "Din ritual",
        addonTitle: "Också värt en titt",
        tipTitle: "En liten vana",
        addToCart: "Lägg ritualen i varukorgen",
        adding: "Lägger till…",
        added: "Tillagd i varukorgen",
        viewProduct: "Visa produkt",
        retake: "Gör om testet",
        disclaimerTitle: "Värt att veta",
        disclaimer: "Det här testet är en kosmetisk guide för produktval, inte en medicinsk bedömning. Om du märker ett ihållande hudbekymmer, kontakta gärna en specialist.",
        spfTitle: "Ett tillägg för dagtid",
        spf: "Utöver din dagkräm, lägg till ett solskydd som passar årstiden.",
        spfLink: "Utforska Solskydd",
      },
    };
    var I18N = I18N_BY_LANG[LANG] || I18N_BY_LANG.en;

    var intro = section.querySelector('[data-m108-quiz-intro]');
    var stage = section.querySelector('[data-m108-quiz-stage]');
    var qWrap = section.querySelector('[data-m108-quiz-question]');
    var progressFill = section.querySelector('[data-m108-quiz-progress-fill]');
    var progressBar = section.querySelector('[data-m108-quiz-progress]');
    var backBtn = section.querySelector('[data-m108-quiz-back]');
    var startBtn = section.querySelector('[data-m108-quiz-start]');
    var resultEl = section.querySelector('[data-m108-quiz-result]');

    section.querySelectorAll('[data-m108-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-m108-i18n');
      if (I18N[key]) el.textContent = I18N[key];
    });

    var scored = DATA.questions.filter(function (q) { return q.scored; });
    var guessQ = DATA.questions.filter(function (q) { return !q.scored; })[0];
    var order = (guessQ ? [guessQ] : []).concat(scored);

    var step = 0;
    var answers = {}; // questionId -> optionId
    var guessValue = null;

    function axisScores() {
      var s = {};
      scored.forEach(function (q) {
        var chosen = answers[q.id];
        if (!chosen) return;
        var opt = q.options.filter(function (o) { return o.id === chosen; })[0];
        if (!opt || !opt.scores) return;
        Object.keys(opt.scores).forEach(function (ax) {
          s[ax] = (s[ax] || 0) + opt.scores[ax];
        });
      });
      return s;
    }

    // Python classify()/addons() ile birebir aynı eşikler.
    function classify(s) {
      var g = function (a) { return s[a] || 0; };
      if (g('hassasiyet') >= 4) return 'hassas';
      if (g('bolge') >= 6) return 'karma';
      if (g('nem') >= 6 && g('yag') >= 5) return 'susuz';
      if (g('nem') >= 6 && g('yag') < 5) return 'kuru';
      if (g('yag') >= 6) return 'yagli';
      if (g('bolge') >= 3) return 'karma';
      return 'susuz';
    }

    function addonKey(s) {
      var leke = s.leke || 0, cizgi = s.cizgi || 0;
      if (leke >= 3 && cizgi >= 3) return 'radiance_duo';
      if (leke >= 3) return 'leke';
      if (cizgi >= 3) return 'cizgi';
      return null;
    }

    function renderQuestion() {
      var q = order[step];
      var isGuess = !q.scored;
      var total = order.length;
      var displayIndex = step + 1;

      if (progressBar) {
        var pct = Math.round((step / total) * 100);
        progressBar.setAttribute('aria-valuenow', String(pct));
        if (progressFill) progressFill.style.width = pct + '%';
      }

      var optsHtml = q.options
        .map(function (o) {
          return (
            '<button type="button" class="m108-quiz__option" role="radio" aria-checked="false" data-option="' +
            o.id +
            '">' +
            '<span class="m108-quiz__option-mark" aria-hidden="true"></span>' +
            '<span class="m108-quiz__option-text">' +
            escapeHtml(tObj(o)) +
            '</span></button>'
          );
        })
        .join('');

      qWrap.innerHTML =
        '<p class="m108-quiz__step">' + escapeHtml(I18N.progress(displayIndex, total)) + '</p>' +
        '<h2 class="m108-quiz__prompt">' + escapeHtml(tObj(q)) + '</h2>' +
        '<div class="m108-quiz__options" role="radiogroup" data-m108-quiz-options>' + optsHtml + '</div>';

      var optionButtons = qWrap.querySelectorAll('[data-option]');
      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var oid = btn.getAttribute('data-option');
          if (isGuess) {
            var opt = q.options.filter(function (o) { return o.id === oid; })[0];
            guessValue = opt ? opt.guess : null;
          } else {
            answers[q.id] = oid;
          }
          window.setTimeout(advance, 180);
          optionButtons.forEach(function (b) {
            b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
            b.classList.toggle('is-selected', b === btn);
          });
        });
      });

      backBtn.hidden = step === 0;
      var h2 = qWrap.querySelector('h2');
      if (h2) h2.setAttribute('tabindex', '-1');
      window.requestAnimationFrame(function () {
        if (h2 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) h2.focus();
      });
    }

    function advance() {
      if (step < order.length - 1) {
        step++;
        renderQuestion();
      } else {
        showResult();
      }
    }

    function goBack() {
      if (step > 0) {
        step--;
        renderQuestion();
      }
    }

    function escapeHtml(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : s;
      return d.innerHTML;
    }

    function productCard(handle, stepLabel, why) {
      var p = PRODUCTS[handle];
      if (!p) return '';
      var img = p.image
        ? '<img src="' + p.image + '" alt="" loading="lazy" width="120" height="120">'
        : '';
      return (
        '<li class="m108-quiz__product" data-variant-id="' + (p.available ? p.variant_id : '') + '">' +
        '<a class="m108-quiz__product-media" href="' + p.url + '">' + img + '</a>' +
        '<div class="m108-quiz__product-body">' +
        (stepLabel ? '<p class="m108-quiz__product-step">' + escapeHtml(stepLabel) + '</p>' : '') +
        '<a class="m108-quiz__product-title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
        '<p class="m108-quiz__product-price">' + escapeHtml(p.price) + '</p>' +
        (why ? '<p class="m108-quiz__product-why">' + escapeHtml(why) + '</p>' : '') +
        '</div></li>'
      );
    }

    function showResult() {
      var scores = axisScores();
      var typeKey = classify(scores);
      var outcome = CONTENT.outcomes.filter(function (o) { return o.key === typeKey; })[0];
      if (!outcome) return;

      var addKey = addonKey(scores);
      var addon = addKey ? CONTENT.addons.filter(function (a) { return a.key === addKey; })[0] : null;

      var guessLine = '';
      if (guessValue) {
        var typeName = tField(outcome, 'name');
        var guessName = guessLabel(guessValue);
        guessLine =
          '<p class="m108-quiz__guess">' +
          escapeHtml(guessValue === typeKey ? I18N.guessSame : I18N.guessDiff(guessName, typeName)) +
          '</p>';
      }

      var traits = tField(outcome, 'traits') || [];
      var traitsHtml = traits.length
        ? '<ul class="m108-quiz__traits">' +
          traits.map(function (x) { return '<li>' + escapeHtml(x) + '</li>'; }).join('') +
          '</ul>'
        : '';

      var routineHtml = outcome.routine
        .map(function (r) {
          return productCard(r.handle, tField(r, 'step'), tField(r, 'why'));
        })
        .join('');

      var addonHtml = '';
      if (addon) {
        var addonProducts = (addon.handle_or_handles || [])
          .map(function (h) { return productCard(h, null, null); })
          .join('');
        addonHtml =
          '<div class="m108-quiz__addon">' +
          '<p class="m108-kicker">' + escapeHtml(I18N.addonTitle) + '</p>' +
          '<h3 class="m108-quiz__addon-label">' + escapeHtml(tField(addon, 'label')) + '</h3>' +
          '<p class="m108-copy">' + escapeHtml(tField(addon, 'text')) + '</p>' +
          '<ul class="m108-quiz__products m108-quiz__products--addon">' + addonProducts + '</ul>' +
          '</div>';
      }

      var allHandles = outcome.routine.map(function (r) { return r.handle; });
      if (addon) allHandles = allHandles.concat(addon.handle_or_handles || []);

      resultEl.innerHTML =
        '<div class="m108-quiz__result-inner m108-reveal is-visible">' +
        '<p class="m108-kicker">' + escapeHtml(I18N.resultKicker) + '</p>' +
        '<h2 class="m108-section-title">' + escapeHtml(tField(outcome, 'name')) + '</h2>' +
        guessLine +
        '<p class="m108-copy m108-quiz__lede">' + escapeHtml(tField(outcome, 'lede')) + '</p>' +
        traitsHtml +
        '<h3 class="m108-quiz__routine-title">' + escapeHtml(I18N.routineTitle) + '</h3>' +
        '<ul class="m108-quiz__products" data-m108-quiz-routine>' + routineHtml + '</ul>' +
        addonHtml +
        '<div class="m108-quiz__spf">' +
        '<p class="m108-kicker">' + escapeHtml(I18N.spfTitle) + '</p>' +
        '<p class="m108-copy">' + escapeHtml(I18N.spf) + ' ' +
        '<a class="m108-text-link" href="/collections/sun-care">' + escapeHtml(I18N.spfLink) + '</a></p>' +
        '</div>' +
        '<p class="m108-quiz__tip"><strong>' + escapeHtml(I18N.tipTitle) + '.</strong> ' +
        escapeHtml(tField(outcome, 'tip')) + '</p>' +
        '<div class="m108-quiz__actions">' +
        '<button type="button" class="button m108-quiz__add-all" data-m108-quiz-addall data-handles=\'' +
        JSON.stringify(allHandles) + '\'>' + escapeHtml(I18N.addToCart) + '</button>' +
        '<button type="button" class="m108-text-link" data-m108-quiz-retake>' + escapeHtml(I18N.retake) + '</button>' +
        '</div>' +
        '<div class="m108-quiz__disclaimer">' +
        '<h3>' + escapeHtml(I18N.disclaimerTitle) + '</h3>' +
        '<p>' + escapeHtml(I18N.disclaimer) + '</p>' +
        '</div>' +
        '</div>';

      stage.hidden = true;
      resultEl.hidden = false;

      var addAllBtn = resultEl.querySelector('[data-m108-quiz-addall]');
      if (addAllBtn) addAllBtn.addEventListener('click', function () { addAllToCart(addAllBtn); });
      var retakeBtn = resultEl.querySelector('[data-m108-quiz-retake]');
      if (retakeBtn) retakeBtn.addEventListener('click', resetQuiz);

      var h2 = resultEl.querySelector('h2');
      if (h2) {
        h2.setAttribute('tabindex', '-1');
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) h2.focus();
      }
    }

    function guessLabel(key) {
      var o = CONTENT.outcomes.filter(function (x) { return x.key === key; })[0];
      return o ? tField(o, 'name') : key;
    }

    function addAllToCart(btn) {
      var handles = JSON.parse(btn.getAttribute('data-handles') || '[]');
      var items = handles
        .map(function (h) { return PRODUCTS[h]; })
        .filter(function (p) { return p && p.available && p.variant_id; })
        .map(function (p) { return { id: p.variant_id, quantity: 1 }; });
      if (!items.length) return;

      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = I18N.adding;

      fetch(window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
        .then(function () {
          btn.textContent = I18N.added;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    }

    function resetQuiz() {
      step = 0;
      answers = {};
      guessValue = null;
      resultEl.hidden = true;
      resultEl.innerHTML = '';
      intro.hidden = false;
      stage.hidden = true;
    }

    startBtn.addEventListener('click', function () {
      intro.hidden = true;
      stage.hidden = false;
      step = 0;
      renderQuestion();
    });
    backBtn.addEventListener('click', goBack);
  }


  // ══ M108 HIZLI DİL DEĞİŞTİRİCİ ══════════════════════════════════════════
  // Mevcut TRY/EN seçici önce 100+ ülkelik listeyi gösteriyor, dil seçimi
  // onun ALTINDA küçük bir alt-bölüm olarak duruyordu (3 tıklama + arama).
  // Bu modül header'a AYRI, doğrudan dile giden bir kısayol ekliyor.
  //
  // Stok localization-form-component'e DOKUNMUYOR — yalnızca DOM'a yeni bir
  // buton ekleyip, o formun KENDİ <select name="language_code"> elemanını
  // programlı olarak değiştirip resmi 'change' event'ini tetikliyor. Böylece
  // Shopify'ın kendi dil/pazar mantığı (cookie, para birimi, çeviri) aynen
  // çalışmaya devam ediyor; biz yalnızca ona ulaşmayı hızlandırıyoruz.
  function initQuickLangToggle(root) {
    var doc = (root && root.querySelectorAll) ? root : document;
    var hosts = doc.querySelectorAll('.dropdown-localization:not(.m108-lang-bound)');
    Array.prototype.forEach.call(hosts, function (host) {
      host.classList.add('m108-lang-bound');
      buildToggle(host);
    });
  }

  function buildToggle(host) {
    var select = host.querySelector('select[name="language_code"]');
    if (!select || select.options.length < 2) return;

    // host (TRY/TR seçici) ile bu butonu TEK bir flex grubunda birleştiriyoruz.
    // Bunu yapmazsak header__column--right'ın kendi 20px flex-gap'i butonu
    // TRY/TR'den değil arama/hesap/sepet ikonlarından ayırt edilemez hale
    // getiriyor — sanki alakasız, ayrı bir menü öğesiymiş gibi görünüyor.
    var group = document.createElement('div');
    group.className = 'm108-lang-group';
    host.parentNode.insertBefore(group, host);
    group.appendChild(host);

    var wrap = document.createElement('div');
    wrap.className = 'm108-lang-quick';

    var options = Array.prototype.map.call(select.options, function (o) {
      return { code: o.value, label: o.textContent.trim() };
    });

    if (options.length === 2) {
      // İki dil: tek tık = anında karşı dile geçer, ayrı liste açmaya gerek yok.
      var btn = document.createElement('button');
      btn.type = 'button';
      // header-actions__action: temanın arama/hesap/sepet ikonlarında kullandığı
      // sınıf. Rengi (--color-foreground üzerinden, header şeffaf/dolu durumuna
      // göre otomatik) ve tipografiyi (uppercase, 44px min-height) bu sınıftan
      // miras alıyoruz — böylece header'daki diğer aksiyon düğmeleriyle birebir
      // tutarlı görünür, ayrı/yabancı bir eleman gibi durmaz.
      btn.className = 'm108-lang-quick__btn header-actions__action';
      btn.setAttribute('aria-label', 'Switch language');
      var setLabel = function () {
        var current = select.value;
        var other = options.filter(function (o) { return o.code !== current; })[0] || options[0];
        btn.textContent = other.code.toUpperCase();
        btn.dataset.target = other.code;
      };
      setLabel();
      btn.addEventListener('click', function () {
        switchLanguage(select, btn.dataset.target);
      });
      wrap.appendChild(btn);
      // dil değiştikten sonra (sayfa aynı kalıp içerik güncellenirse) etiketi tazele
      select.addEventListener('change', function () {
        window.setTimeout(setLabel, 50);
      });
    } else {
      // 3+ dil: doğrudan dil listesini açan kompakt bir açılır menü —
      // ülke listesi hiç araya girmiyor.
      var current = document.createElement('button');
      current.type = 'button';
      current.className = 'm108-lang-quick__btn header-actions__action';
      current.setAttribute('aria-haspopup', 'listbox');
      current.setAttribute('aria-expanded', 'false');
      var updateCurrent = function () {
        var opt = options.filter(function (o) { return o.code === select.value; })[0];
        current.textContent = (opt ? opt.code : select.value).toUpperCase();
      };
      updateCurrent();

      var list = document.createElement('ul');
      list.className = 'm108-lang-quick__list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      options.forEach(function (o) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = o.label;
        b.className = 'm108-lang-quick__option';
        if (o.code === select.value) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () {
          list.hidden = true;
          current.setAttribute('aria-expanded', 'false');
          switchLanguage(select, o.code);
        });
        li.appendChild(b);
        list.appendChild(li);
      });

      current.addEventListener('click', function () {
        var open = list.hidden;
        list.hidden = !open;
        current.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          list.hidden = true;
          current.setAttribute('aria-expanded', 'false');
        }
      });

      wrap.appendChild(current);
      wrap.appendChild(list);
    }

    // v4 (2026-08-06): butonu grubun İÇİNDE bırakmak mobilde ÜST ÜSTE BİNMEYE
    // yol açıyordu — .header__column--right `display:contents` olduğu için
    // çocukları doğrudan header grid'ine giriyor ve grup, <header-actions>
    // ile AYNI hücreye yerleşiyordu (dil butonu hesap ikonunun üstüne biniyor).
    // Çözüm: butonu ayrı bir grid çocuğu yapmak yerine <header-actions>'ın
    // (hesap + sepet) kendi flex akışına sokuyoruz — hem çakışma bitiyor hem de
    // masaüstünde zaten görsel olarak ait olduğu kümeye giriyor.
    // host (gizli TRY/TR component'i) grupta kalıyor: select'i JS okuyor.
    var actions = document.querySelector('header-actions, .header-actions');
    if (actions) {
      actions.insertBefore(wrap, actions.firstChild);
    } else {
      group.appendChild(wrap);
    }
  }

  function switchLanguage(select, code) {
    if (!code || select.value === code) return;
    select.value = code;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }


  // ══ M108 COĞRAFİ DİL ÖNERİSİ ═══════════════════════════════════════════
  // Ziyaretçi Türkiye'den (veya Almanya/Fransa/İspanya/Arap ülkelerinden)
  // geliyorsa ve site o an kendi dilinde DEĞİLSE, tek seferlik nazik bir
  // öneri gösterir. Kabul ederse dili değiştirir, reddederse bir daha
  // sormaz (localStorage).
  //
  // Dil değiştirme işini KENDİ başına yapmıyor: mevcut switchLanguage()
  // üzerinden Shopify'ın kendi <select name="language_code"> mekanizmasını
  // tetikliyor. Böylece pazar/para birimi/çerez mantığı bozulmuyor.
  /* ══ M108 HOŞ GELDİN TEKLİFİ ═══════════════════════════════════════════════
     E-posta karşılığı indirim kodu. Kod, section'ın bastığı JSON'dan okunur —
     JS içine gömülmez ki tema editöründen değiştirilebilsin.

     Dil önerisi popup'ıyla ÇAKIŞMAZ: m108-geo açıkken sayaç hiç başlamaz,
     geo kapanınca baştan başlar. İkisi aynı anda ekranda olursa ikisi de
     görmezden gelinir — bu, ilk ziyaretin tamamen popup'a boğulmasını önler.

     Kayıt, temanın kendi bülten formuyla AYNI uca gider (/contact,
     form_type=customer). Ayrı servis/uygulama yok; kişi Shopify'ın bülten
     listesine düşer. Ağ hatasında kod YİNE de gösterilir — ziyaretçiyi
     bizim altyapı sorunumuz yüzünden indirimsiz bırakmak doğru değil. */
  var M108_WELCOME_KEY = 'm108-welcome-offer-done';

  function initWelcomeOffer() {
    var dataEl = document.querySelector('script[type="application/json"][data-m108-welcome]');
    if (!dataEl) return;
    if (document.documentElement.hasAttribute('data-m108-welcome-done')) return;

    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!cfg || !cfg.code) return;

    var done;
    try { done = window.localStorage.getItem(M108_WELCOME_KEY); } catch (e) { done = null; }
    if (done) return;

    // Sepeti dolu olan / ödeme adımındaki ziyaretçiyi bölmeyelim.
    if (/\/(cart|checkouts?|account)(\/|$)/.test(window.location.pathname)) return;

    document.documentElement.setAttribute('data-m108-welcome-done', '1');

    var delayMs = Math.max(0, (parseInt(cfg.delay, 10) || 0)) * 1000;
    var timer = null;

    function schedule() {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (document.querySelector('.m108-geo')) { schedule(); return; }  // dil popup'ı hâlâ açık
        buildWelcome(cfg);
      }, delayMs);
    }
    schedule();
  }

  function buildWelcome(cfg) {
    var seen;
    try { seen = window.localStorage.getItem(M108_WELCOME_KEY); } catch (e) { seen = null; }
    if (seen) return;

    var overlay = document.createElement('div');
    overlay.className = 'm108-welcome';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', cfg.title);

    var box = document.createElement('div');
    box.className = 'm108-welcome__box';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'm108-welcome__close';
    close.setAttribute('aria-label', cfg.close);
    close.innerHTML = '&times;';

    var eyebrow = document.createElement('p');
    eyebrow.className = 'm108-welcome__eyebrow';
    eyebrow.textContent = cfg.eyebrow;

    var title = document.createElement('h2');
    title.className = 'm108-welcome__title';
    title.textContent = cfg.title;

    var body = document.createElement('p');
    body.className = 'm108-welcome__body';
    body.textContent = cfg.body;

    var form = document.createElement('form');
    form.className = 'm108-welcome__form';
    form.noValidate = true;

    var input = document.createElement('input');
    input.type = 'email';
    input.required = true;
    input.className = 'm108-welcome__input';
    input.placeholder = cfg.placeholder;
    input.setAttribute('aria-label', cfg.placeholder);
    input.autocomplete = 'email';

    var submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'm108-welcome__btn';
    submit.textContent = cfg.cta;

    var note = document.createElement('p');
    note.className = 'm108-welcome__fineprint';
    note.textContent = cfg.fineprint;

    // ── başarı görünümü (başta gizli) ──
    var result = document.createElement('div');
    result.className = 'm108-welcome__result';
    result.hidden = true;

    var resultMsg = document.createElement('p');
    resultMsg.className = 'm108-welcome__result-msg';
    resultMsg.textContent = cfg.success;

    var codeRow = document.createElement('div');
    codeRow.className = 'm108-welcome__code-row';

    var codeEl = document.createElement('span');
    codeEl.className = 'm108-welcome__code';
    codeEl.textContent = cfg.code;

    var copyBtn = document.createElement('button');
    copyBtn.type = 'button';
    copyBtn.className = 'm108-welcome__copy';
    copyBtn.textContent = cfg.copy;
    copyBtn.addEventListener('click', function () {
      var ok = function () {
        copyBtn.textContent = cfg.copied;
        window.setTimeout(function () { copyBtn.textContent = cfg.copy; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(cfg.code).then(ok, function () {});
      } else {
        // eski Safari/iOS: geçici bir input üzerinden seç-kopyala
        var tmp = document.createElement('input');
        tmp.value = cfg.code;
        document.body.appendChild(tmp);
        tmp.select();
        try { document.execCommand('copy'); ok(); } catch (e) {}
        document.body.removeChild(tmp);
      }
    });

    codeRow.appendChild(codeEl);
    codeRow.appendChild(copyBtn);
    result.appendChild(resultMsg);
    result.appendChild(codeRow);

    var errEl = document.createElement('p');
    errEl.className = 'm108-welcome__error';
    errEl.hidden = true;
    errEl.textContent = cfg.error;

    function markDone() {
      try { window.localStorage.setItem(M108_WELCOME_KEY, '1'); } catch (e) {}
    }
    function dismiss() {
      markDone();
      overlay.remove();
      document.documentElement.style.removeProperty('overflow');
    }
    function reveal() {
      markDone();
      form.hidden = true;
      body.hidden = true;
      errEl.hidden = true;
      result.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var value = (input.value || '').trim();
      if (!value || value.indexOf('@') < 1) { input.focus(); return; }
      submit.disabled = true;
      errEl.hidden = true;

      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', value);
      fd.append('contact[tags]', 'newsletter,welcome-offer');

      window.fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function () { reveal(); })
        .catch(function () { reveal(); })   // ağ hatası kodu engellemesin
        .then(function () { submit.disabled = false; });
    });

    close.addEventListener('click', dismiss);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) dismiss(); });
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape' && document.body.contains(overlay)) { dismiss(); document.removeEventListener('keydown', onEsc); }
    });

    form.appendChild(input);
    form.appendChild(submit);
    box.appendChild(close);
    box.appendChild(eyebrow);
    box.appendChild(title);
    box.appendChild(body);
    box.appendChild(form);
    box.appendChild(errEl);
    box.appendChild(result);
    box.appendChild(note);
    overlay.appendChild(box);
    document.body.appendChild(overlay);
    window.setTimeout(function () { input.focus(); }, 60);
  }


  function initGeoLangSuggest(root) {

  var M108_GEO_KEY = 'm108-lang-suggest-dismissed';
  var M108_COUNTRY_LANG = {
    TR: 'tr',
    DE: 'de', AT: 'de', CH: 'de', LI: 'de',
    FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr',
    ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es',
    SA: 'ar', AE: 'ar', EG: 'ar', QA: 'ar', KW: 'ar', BH: 'ar', OM: 'ar',
    JO: 'ar', LB: 'ar', IQ: 'ar', MA: 'ar', DZ: 'ar', TN: 'ar', LY: 'ar',
    YE: 'ar', SY: 'ar', PS: 'ar', SD: 'ar'
  };

    // Sadece bir kez, sayfa genelinde (section re-render'da tekrar açmasın)
    if (document.documentElement.hasAttribute('data-m108-geo-done')) return;

    var dataEl = document.querySelector('script[type="application/json"][data-m108-geo]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.country) return;

    var target = M108_COUNTRY_LANG[data.country];
    if (!target) return;                       // bu ülke için önerecek yerel dil yok
    if (target === data.current) return;       // zaten o dilde

    var available = (data.available || []).map(function (l) { return l.code; });
    if (available.indexOf(target) === -1) return;  // o dil bu pazarda yayında değil

    var dismissed;
    try { dismissed = window.localStorage.getItem(M108_GEO_KEY); } catch (e) { dismissed = null; }
    if (dismissed) return;

    document.documentElement.setAttribute('data-m108-geo-done', '1');
    renderGeoSuggest(target, data);
  }

  function renderGeoSuggest(target, data) {
  var M108_GEO_KEY = 'm108-lang-suggest-dismissed';
  var M108_GEO_COPY = {
    tr: { title: '{country} konumundasınız', body: 'Siteyi Türkçe görüntülemek ister misiniz?', accept: 'Türkçe devam et', decline: 'Continue in English' },
    de: { title: 'Sie besuchen uns aus {country}', body: 'Möchten Sie die Seite auf Deutsch ansehen?', accept: 'Auf Deutsch fortfahren', decline: 'Continue in English' },
    fr: { title: 'Vous nous rendez visite depuis {country}', body: 'Souhaitez-vous consulter le site en français ?', accept: 'Continuer en français', decline: 'Continue in English' },
    es: { title: 'Nos visitas desde {country}', body: '¿Quieres ver el sitio en español?', accept: 'Continuar en español', decline: 'Continue in English' },
    ar: { title: 'يبدو أنك تزورنا من {country}', body: 'هل تود عرض الموقع باللغة العربية؟', accept: 'المتابعة بالعربية', decline: 'Continue in English' }
  };

    var copy = M108_GEO_COPY[target];
    if (!copy) return;

    var countryName = data.countryName || data.country;

    var overlay = document.createElement('div');
    overlay.className = 'm108-geo';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'false');
    overlay.setAttribute('aria-label', copy.title.replace('{country}', countryName));

    var box = document.createElement('div');
    box.className = 'm108-geo__box';

    var h = document.createElement('p');
    h.className = 'm108-geo__title';
    h.textContent = copy.title.replace('{country}', countryName);

    var b = document.createElement('p');
    b.className = 'm108-geo__body';
    b.textContent = copy.body;

    var actions = document.createElement('div');
    actions.className = 'm108-geo__actions';

    var accept = document.createElement('button');
    accept.type = 'button';
    accept.className = 'm108-geo__btn m108-geo__btn--accept';
    accept.textContent = copy.accept;

    var decline = document.createElement('button');
    decline.type = 'button';
    decline.className = 'm108-geo__btn m108-geo__btn--decline';
    decline.textContent = copy.decline;

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'm108-geo__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';

    function remember() {
      try { window.localStorage.setItem(M108_GEO_KEY, '1'); } catch (e) {}
    }
    function dismiss() {
      remember();
      overlay.classList.remove('is-in');
      window.setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 240);
    }

    accept.addEventListener('click', function () {
      remember();
      var select = document.querySelector('select[name="language_code"]');
      if (select) switchLanguage(select, target);
      else dismiss();
    });
    decline.addEventListener('click', dismiss);
    // karartılmış zemine tıklayınca da kapansın (kutunun içi hariç)
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });
    close.addEventListener('click', dismiss);

    actions.appendChild(accept);
    actions.appendChild(decline);
    box.appendChild(close);
    box.appendChild(h);
    box.appendChild(b);
    box.appendChild(actions);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    // giriş animasyonu (reduced-motion CSS tarafında saygı görüyor)
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { overlay.classList.add('is-in'); });
    });
  }

})();
